export default __webpack_public_path__ + "static/media/LEVEL11.c390bfe0.png";